import type { MagentoApiRemoveItemFromCartMutationResponse } from "@jti/magento-api-v2";

import { TAGS } from "../common/tags";
import type { MagentoApiBuilder } from "../magentoApiSlice";

export const removeItemFromCartEndpoint = (builder: MagentoApiBuilder) => ({
  removeItemFromCart: builder.mutation<
    MagentoApiRemoveItemFromCartMutationResponse,
    { cartId: string; itemId: number }
  >({
    query: ({ cartId, itemId }) => ({
      method: "removeItemFromCart",
      params: [{ cartId, itemId }],
    }),
    invalidatesTags: [TAGS.CART_ITEMS, TAGS.CART_ORDER_PRICES],
  }),
});
